import styled from '@emotion/styled'

export const FooterContainer = styled.footer`
  position: absolute;
  bottom: 0px;

  width: 100%;
  margin: 12px 0;

  font-family: 'simpleStamp', sans-serif;
  color: var(--white);
  font-size: 12px;
  text-align: center;

  opacity: 0.5;
`
